import PageShell from "./PageShell";
import PillarSection from "@/components/site/PillarSection";
import { IMAGES } from "@/lib/content";

const GALLERY = [
  { src: IMAGES.restoreYoga, label: "Fireside Meditation" },
  { src: IMAGES.restoreYin, label: "Yin Yoga" },
  { src: IMAGES.restoreSauna, label: "Private Sauna" },
  { src: IMAGES.restoreHotStone, label: "Hot Stone Massage" },
];

export default function RestorePage() {
  return (
    <PageShell testId="page-restore">
      <PillarSection
        pillarKey="Restore"
        heroImage={IMAGES.restoreYin}
        galleryImages={GALLERY}
      />
    </PageShell>
  );
}
